(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const countdown = root.querySelector('[data-countdown]');
    if (countdown) {
      const end = Date.parse(countdown.dataset.end);
      let timer;
      const updateCountdown = () => {
        const remaining = Math.max(0, Math.ceil((end - Date.now()) / 1000));
        if (!Number.isFinite(remaining)) return;
        const values = {
          days: Math.floor(remaining / 86400),
          hours: Math.floor(remaining / 3600) % 24,
          minutes: Math.floor(remaining / 60) % 60,
          seconds: remaining % 60
        };
        Object.entries(values).forEach(([unit, value]) => {
          countdown.querySelector(`[data-time="${unit}"]`).textContent = String(value).padStart(2, '0');
        });
        countdown.hidden = false;
        if (remaining === 0) {
          clearInterval(timer);
          countdown.classList.add('hp-s__countdown--ended');
          countdown.querySelector('.hp-s__countdown-title').textContent = countdown.dataset.ended;
          root.querySelectorAll('.hp-s__option--pair, .hp-s__discount-note, .hp-s__pill, .hp-s__deadline').forEach(el => { el.hidden = true; });
          const single = root.querySelector('input[name="quantity"][value="1"]');
          if (single) single.checked = true;
        }
      };
      updateCountdown();
      if (end > Date.now()) timer = setInterval(updateCountdown, 1000);
      document.addEventListener('visibilitychange', () => { if (!document.hidden) updateCountdown(); });
    }
    const video = root.querySelector('[data-demo-video]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const slides = [...root.querySelectorAll('[data-slide]')];
    const thumbs = [...root.querySelectorAll('[data-show-slide]')];
    let current = '0';
    let userControlled = false;
    let programmaticPause = false;
    const pauseVideo = () => {
      if (video && !video.paused) {
        programmaticPause = true;
        video.pause();
      }
    };
    if (video) {
      video.addEventListener('pause', () => {
        if (programmaticPause) programmaticPause = false;
        else userControlled = true;
      });
      video.addEventListener('play', () => { userControlled = false; });
    }
    thumbs.forEach(button => button.addEventListener('click', () => {
      current = button.dataset.showSlide;
      slides.forEach(slide => { slide.hidden = slide.dataset.slide !== current; });
      thumbs.forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb === button)));
      const caption = root.querySelector('.hp-s__caption');
      if (caption) caption.style.visibility = current === '0' ? 'visible' : 'hidden';
      if (current !== '0') pauseVideo();
      else if (video && !reduced.matches && !userControlled) video.play().catch(() => {});
    }));
    if ('IntersectionObserver' in window && video) {
      new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && current === '0' && !reduced.matches && !document.hidden && !userControlled) video.play().catch(() => {});
          else pauseVideo();
        });
      }, { threshold: .2 }).observe(video);
    }
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) pauseVideo();
    });
    reduced.addEventListener('change', () => { if (reduced.matches) pauseVideo(); });
    const reveals = [...root.querySelectorAll('.hp-s__reveal')];
    if ('IntersectionObserver' in window && !reduced.matches) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.remove('hp-s__pending'); observer.unobserve(entry.target); }
      }), { rootMargin: '0px 0px -30px 0px', threshold: .05 });
      reveals.forEach(el => {
        if (el.getBoundingClientRect().top > window.innerHeight) el.classList.add('hp-s__pending');
        observer.observe(el);
      });
    }
    const sticky = root.querySelector('[data-sticky]');
    const buy = root.querySelector('.hp-s__form');
    if (buy && typeof window.fetch === 'function') {
      let submitting = false;
      buy.addEventListener('submit', async event => {
        event.preventDefault();
        if (submitting) return;
        submitting = true;
        const body = new FormData(buy);
        const buttons = [...buy.querySelectorAll('[type="submit"]')];
        const disabledStates = buttons.map(button => button.disabled);
        buttons.forEach(button => { button.disabled = true; });
        buy.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch('/cart/add.js', { method: 'POST', body });
          if (!response.ok) throw new Error('Cart request failed');
        } catch {
          buttons.forEach((button, index) => { button.disabled = disabledStates[index]; });
          buy.removeAttribute('aria-busy');
          submitting = false;
          // Bypass this listener and preserve the original Shopify POST fallback.
          HTMLFormElement.prototype.submit.call(buy);
          return;
        }
        window.location.href = '/cart';
      });
    }
    if (sticky && buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(entries => entries.forEach(entry => {
        sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
      })).observe(buy);
    }
  }
  document.querySelectorAll('[data-hp-sealer]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-hp-sealer]').forEach(init));
})();
